import React from 'react';
import '../styles/ReviewCard.css';

const ReviewCard = ({ title, rating, text }) => {
  return (
    <div className="review-card">
      <div className="review-title">{title}</div>
      <div className="star-rating">{'★'.repeat(rating)}{'☆'.repeat(5-rating)}</div>
      <div className="review-text">{text}</div>
    </div>
  );
};

export default ReviewCard; 